// The business's WhatsApp number, in international format without the leading "+".
// Kept in one place so it's easy to update everywhere it's used (forms + contact links).
export const BUSINESS_WHATSAPP_NUMBER = "33753310324";

export function buildWhatsAppLink(message, phoneNumber = BUSINESS_WHATSAPP_NUMBER) {
  return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
}

// Must be called synchronously from a user gesture (e.g. a submit handler)
// so the browser doesn't block it as an unrequested popup.
export function openWhatsAppChat(message, phoneNumber = BUSINESS_WHATSAPP_NUMBER) {
  window.open(buildWhatsAppLink(message, phoneNumber), "_blank", "noopener,noreferrer");
}
